import { Component, inject, OnInit } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';


@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule,
            ToastModule
  ],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})


export class ToastComponent implements OnInit {
  
  toastService = inject(ToastService)

  constructor() { }
  
  ngOnInit() { }

  get mensagemToast(): string {
    return this.toastService.getMensagemToast();
  }

  get toastEhVisivel(): boolean {
    return this.toastService.toastEhVisivel();
  }

  ocultaToast() {
    this.toastService.ocultaToast();
  }
}